import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../app/store/baseQuery";
import { qwDimensions } from "../../app/clients/qwDimensions";
import { createChunkedQueryFn } from "../../utils/query";

export const dimensionsBaseApi = createApi({
  reducerPath: "dimensions",
  baseQuery: axiosBaseQuery(qwDimensions),
  endpoints: (builder) => ({
    getAppliance: builder.query({
      query: (id) => ({
        url: `/v2/theatre-appliances/${id}`,
        method: "GET",
      }),
    }),
    searchChains: builder.query({
      query: ({ q, size, pageToken, hasWiretap }) => ({
        url: `/v1/theatre-chains/search`,
        method: "GET",
        params: { q, size, pageToken, hasWiretap },
      }),
      keepUnusedDataFor: 86400,
    }),
    getManyAppliances: builder.query({
      queryFn: createChunkedQueryFn({
        getChunkSource: ({ applianceIds }) => applianceIds || [],
        query: (id) => ({ url: `/v2/theatre-appliances/${id}` }),
        getData: (result) => result?.data,
        chunkSize: 1,
        concurrency: 50,
      }),
    }),
  }),
});

export const { useGetApplianceQuery, useSearchChainsQuery, useGetManyAppliancesQuery } = dimensionsBaseApi;
